export default __webpack_public_path__ + "static/media/Gulp.d38d1eaf.jpeg";